export default "__VITE_ASSET__DcOw9hDt__"